<template>
  <div class="container">
    <div class="columns">
      <div class="column col-6 col-xs-12"> 
        <button @click="$router.go(-1)" class="btn btn-link"><i class="icon icon-back"></i><span>Back</span></button>
        <!-- <div class="divider"></div> -->
        <!-- <h2>Create a new {{usertype}}</h2> -->
        <form class="form-horizontal">
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Corporate</label>
            </div>
            <div class="col-9">
              <div class="input-group">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="newUser.profile.corporate">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Brand</label>
            </div>
            <div class="col-9">
              <select class="form-select" v-model="newUser.profile.brand">
                <option v-for="(v,k) in brands" :value="k">{{v}}</option>
              </select>
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Business Name</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.business" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-3">
              <label class="form-label">First name</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.firstname" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-3">
              <label class="form-label">Last name</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.lastname" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-3">
              <label class="form-label">Date of birth</label>
            </div>
            <div class="col-9">
              <div class="input-group">
                <input class="form-input" type="text" v-model="dob_d" placeholder="DD" />
                <input class="form-input" type="text" v-model="dob_m" placeholder="MM" />
                <input class="form-input" type="text" v-model="dob_y" placeholder="YYYY" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-3">
              <label class="form-label">Email</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="email" v-model="newUser.email" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Address line 1</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.address1" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Address line 2</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.address2" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Suburb</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.suburb" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Postcode</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.postcode" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Passport number</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.passport" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Country</label>
            </div>
            <div class="col-9">
              <select class="form-select" v-model="newUser.profile.country">
                <option value="">Select</option>
                <option v-for="(v,k) in countries" :value="k">{{k}}</option>
              </select>
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">State</label>
            </div>
            <div class="col-9">
              <select v-if="newUser.profile.country === 'AUSTRALIA'" class="form-select" v-model="newUser.profile.state">
                <option value="NSW">NSW</option>
                <option value="TAS">TAS</option>
                <option value="VIC">VIC</option>
                <option value="ACT">ACT</option>
                <option value="NT">NT</option>
                <option value="WA">WA</option>
                <option value="QLD">QLD</option>
              </select>
              <input v-else class="form-input" type="text" v-model="newUser.profile.state" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Phone</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="tel" v-model="newUser.profile.phone" />
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">Client source</label>
            </div>
            <div class="col-9">
              <select class="form-select" v-model="newUser.profile.source">
                <option value="">Select</option>
                <option v-for="s in sources" :value="s">{{s}}</option>
              </select>
            </div>
          </div>
          <div v-if="newClient" class="form-group">
            <div class="col-3">
              <label class="form-label">More details</label>
            </div>
            <div class="col-9">
              <input class="form-input" type="text" v-model="newUser.profile.details" />
            </div>
          </div>

          <div class="form-group">
            <div class="col-3"></div>
            <div class="col-9">
              <button class="btn btn-primary" @click.prevent="make">Make</button>
            </div>
          </div>
          <div class="form-group">
            <div class="col-3"></div>
            <div class="col-9">
              <span v-if="success" class="label label-success">Success</span>
              <span v-if="error" class="label label-error">{{error}}</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'

export default {
  name: 'newUser',
  props: ['usertype'], // 'client' or 'admin'
  mixins: [utils],
  data () {
    return {
      countries: utils.countries(),
      sources: utils.sources(),
      brands: utils.brands(),
      error: '',
      dob_d: '',
      dob_m: '',
      dob_y: '',
      success: false,
      newUser: {
        email: '',
        level: 6,
        profile: {
          corporate: false,
          brand: 'pl',
          firstname: '',
          lastname: '',
          dob: '', // Set automatically when saving
          business: '',
          address1: '',
          address2: '',
          suburb: '',
          postcode: '',
          state: '',
          country: '',
          passport: '',
          phone: '',
          source: '',
          details: ''
        }
      }
    }
  },
  created () {
    this.$root.$data.pageTitle = 'New ' + this.usertype
    if (this.usertype === 'admin') {
      this.newUser.level = 4
    }
  },
  computed: {
    // Are we making a new client or an admin?
    newClient () {
      return this.usertype === 'client'
    }
  },
  methods: {
    make: function () {
      this.newUser.profile.dob = [this.dob_d, this.dob_m, this.dob_y].join('-')
      axios.post('/api/users/new', this.newUser)
      .then(res => {
        if (res.status === 200) {
          this.success = true
          this.error = ''
        }
      })
      .catch(e => {
        this.success = false
        this.error = e.response.data
      })
    }
  }
}
</script>
<style scoped>
i.icon.icon-back {
  margin: 0 1em 0 0;
  float: left;
  width: 26px;
  height: 26px;
  background-color: #ce4b81;
  border-radius: 50%;
  color: #fff;
}
.btn.btn-link span {
  float: left;
  padding: 3px 0 0 0;
  color: #ce4b81
}
.btn.btn-link:hover i {
  background-color:  #b9336b;
}
.btn.btn-link:hover span {
  color:  #b9336b
}
</style>



// WEBPACK FOOTER //
// newUser.vue?7659563d